import React from 'react';
import {
  Card,
  CardHeader,
  CardContent,
  Box,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Alert,
} from '@mui/material';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';

const AdminGoogleAnalytics = () => {
  return (
    <Card sx={{ borderRadius: 3, boxShadow: '0px 16px 45px rgba(15, 23, 42, 0.12)' }}>
      <CardHeader
        title="Google Analytics"
        subheader="Integrate and view your Google Analytics reports"
        titleTypographyProps={{ variant: 'h5', fontWeight: 700 }}
      />
      <CardContent>
        <Alert severity="info" sx={{ mb: 3 }}>
          To connect Google Analytics, replace the placeholder report ID below with your actual Looker Studio report URL.
        </Alert>

        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
          Integration options:
        </Typography>
        <List dense disablePadding sx={{ mb: 3 }}>
          {[
            'Embed a Google Analytics dashboard using an iframe (Looker Studio / Data Studio).',
            'Fetch data via the Google Analytics Reporting API and display custom charts.',
          ].map((text) => (
            <ListItem key={text} disableGutters sx={{ py: 0.25 }}>
              <ListItemIcon sx={{ minWidth: 24 }}>
                <FiberManualRecordIcon sx={{ fontSize: 8, color: 'primary.main' }} />
              </ListItemIcon>
              <ListItemText primary={text} primaryTypographyProps={{ variant: 'body2' }} />
            </ListItem>
          ))}
        </List>

        <Box
          sx={{
            borderRadius: 2,
            overflow: 'hidden',
            border: '1px solid',
            borderColor: 'divider',
            bgcolor: 'action.hover',
          }}
        >
          <iframe
            title="Google Analytics Dashboard"
            width="100%"
            height="600"
            src="https://lookerstudio.google.com/embed/reporting/your-report-id/page/your-page-id"
            frameBorder="0"
            style={{ border: 0, display: 'block' }}
            allowFullScreen
          />
        </Box>
      </CardContent>
    </Card>
  );
};

export default AdminGoogleAnalytics;
